import { User } from 'src/shared/models/user';
import { SysProductYvNameEnum } from 'src/shared/models/enums/sysProductEnums';

// Kunden är ett riktigt FÖRBUND (flera föreningar) – exakt samma villkor som styr att Organisation-modulen visas i
// vänstermenyn: Organisation-produkten finns OCH kunden har föreningar/distrikt (associationCount/districtCount > 0).
// En enskild förening är inte ett förbund (då saknas Organisation-modulen), även om admin råkar ha MEMBER_READ_ALL.
// Logotyp-valet på fakturan (förbundets logga vs föreningarnas egna) visas bara för förbund – där kan alla användartyper
// (förbunds-, distrikts- och föreningsanvändare) välja. En enskild förening använder förbundets (centrala) logga utan val.
export const isForbundCustomer = (currentUser: User | undefined): boolean =>
  (currentUser?.sysProducts ?? []).some((x) => (x.yvName ?? '').toLowerCase() === SysProductYvNameEnum.Organisation.toLowerCase()) &&
  ((currentUser?.associationCount ?? 0) > 0 || (currentUser?.districtCount ?? 0) > 0);
